import { SOCIAL_PLATFORMS } from 'ui-components';
import { EyeIcon, FireIcon } from '~/components/icons';
import { TIKTOK_PREVIEW_ASPECT_RATIO } from '~/constants';
import { CreatorBenchmarks, TiktokType } from '~/types';
import { formatAbbr } from '~/utils';

import { getContentLink } from '../../MediaPackDetailDefaultScreen.helpers';
import { PLATFORM_METRICS } from '../MediaPackDetailEditHighlightsModal/MediaPackDetailEditHighlightsModal.constants';
import { mapMetricsToMetricCardData } from '../MediaPacksDefaultTemplate/OverviewSection/OverviewSection.mapper';

type TiktokProps = {
  hasManager?: boolean;
  ttContents: TiktokType[];
  isSharedView?: boolean;
};

export const mapTiktokContentToHighlightedContentProps = ({
  hasManager,
  ttContents,
  isSharedView,
}: TiktokProps) =>
  ttContents.map((ttContent) => ({
    aspectRatio: TIKTOK_PREVIEW_ASPECT_RATIO,
    contentFooter: [
      {
        icon: EyeIcon,
        label: `${formatAbbr(ttContent.videoViews)} Views`,
      },
      {
        icon: FireIcon,
        label: `${formatAbbr(ttContent.engagementCount)} Engagements`,
      },
    ],
    contentId: ttContent.id,
    link: getContentLink({
      hasManager,
      id: ttContent.id,
      isSharedView,
      platform: SOCIAL_PLATFORMS.tiktok,
      shareLink: ttContent.shareLink,
    }),
    contentSrc: ttContent.assets?.[0]?.previewUrl ?? '',
  }));

export const mapTiktokMetricsToMetricCardData = (
  metrics: string[],
  creatorBenchmarks: CreatorBenchmarks,
) =>
  mapMetricsToMetricCardData(
    metrics,
    PLATFORM_METRICS.tiktok,
    creatorBenchmarks,
  );
